/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Watermark_Saved_ToastInputs */



/**
* | output |
* | --- |
* | "Watermark settings updated." |
*
* @param {Options_Watermark_Saved_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_watermark_saved_toast = /** @type {((inputs?: Options_Watermark_Saved_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Watermark_Saved_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paramètres du filigrane mis à jour.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wasserzeichen-Einstellungen aktualisiert.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni della filigrana aggiornate.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройки водяного знака обновлены.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ajustes de marca de agua actualizados.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("水印设置已更新。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ウォーターマークの設定を更新しました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वॉटरमार्क सेटिंग्स अपडेट की गईं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Definições de marca de água atualizadas.")
	return /** @type {LocalizedString} */ ("Watermark settings updated.")
});